import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Trainee Selection for Stipend ")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-4" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Phase", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Partner", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Start Date", -1)
const _hoisted_16 = { class: "col-md-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "End Date", -1)
const _hoisted_18 = { class: "col-md-2 mt-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_20 = {
  key: 0,
  class: "pt-4 pb-2"
}
const _hoisted_21 = { class: "card" }
const _hoisted_22 = {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_23 = { class: "card-title m-0" }
const _hoisted_24 = { class: "fw-bolder text-light m-0" }
const _hoisted_25 = { class: "card-body" }
const _hoisted_26 = {
  class: "table",
  style: {"border":"1px solid #7da17d"}
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("thead", { style: {"border-left":"1px solid #a78951"} }, [
  /*#__PURE__*/_createElementVNode("th", {
    class: "text-center bg-success text-white",
    style: {"height":"4vh","font-size":"17px","font-weight":"bold"}
  }, " Rules "),
  /*#__PURE__*/_createElementVNode("th", {
    class: "text-center text-white bg-success",
    style: {"height":"4vh","font-size":"17px","font-weight":"bold"}
  }, " Count ")
], -1)
const _hoisted_28 = {
  class: "bg-light",
  style: {"border-left":"1px solid #a78951"}
}
const _hoisted_29 = { style: {"border-bottom":"1px solid #9ee29e"} }
const _hoisted_30 = {
  class: "text-center",
  style: {"border-bottom":"1px solid #9ee29e"}
}
const _hoisted_31 = { id: "course_count" }
const _hoisted_32 = {
  class: "bg-light",
  style: {"border-left":"1px solid #a78951"}
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", { style: {"border-bottom":"1px solid #9ee29e"} }, " Completed Batches ", -1)
const _hoisted_34 = {
  class: "text-center",
  style: {"border-bottom":"1px solid #9ee29e"}
}
const _hoisted_35 = { id: "batch_count" }
const _hoisted_36 = {
  class: "bg-light",
  style: {"border-left":"1px solid #a78951"}
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", { style: {"border-bottom":"1px solid #9ee29e"} }, " Must have bank account number or mobile banking ", -1)
const _hoisted_38 = {
  rowspan: "2",
  class: "text-center"
}
const _hoisted_39 = { id: "account_count" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("tr", {
  style: {"border-left":"1px solid #a78951","border-bottom":"1px dotted silver"},
  class: "bg-light"
}, [
  /*#__PURE__*/_createElementVNode("td", { style: {"border-bottom":"1px solid #9ee29e"} }, " Must have 80% attendance ")
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("tr", {
  class: "bg-light",
  style: {"border-bottom":"4px dotted #de243f"}
}, null, -1)
const _hoisted_42 = {
  class: "bg-light",
  style: {"border-left":"1px solid #a78951"}
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("td", { style: {"border-bottom":"1px solid #9ee29e"} }, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-checkmark-circle" }),
    /*#__PURE__*/_createTextVNode("Ethnic Minority")
  ])
], -1)
const _hoisted_44 = {
  class: "text-center",
  style: {"border-bottom":"1px solid #9ee29e"}
}
const _hoisted_45 = { id: "ethnicity_count" }
const _hoisted_46 = {
  class: "bg-light",
  style: {"border-left":"1px solid #a78951"}
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("td", { style: {"border-bottom":"1px solid #9ee29e"} }, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-checkmark-circle" }),
    /*#__PURE__*/_createTextVNode("Physically Disabled")
  ])
], -1)
const _hoisted_48 = {
  class: "text-center",
  style: {"border-bottom":"1px solid #9ee29e"}
}
const _hoisted_49 = { id: "disabled_count" }
const _hoisted_50 = {
  class: "bg-light",
  style: {"border-left":"1px solid #a78951"}
}
const _hoisted_51 = { style: {"border-bottom":"1px solid #9ee29e"} }
const _hoisted_52 = {
  class: "text-center",
  style: {"border-bottom":"1px solid #9ee29e"}
}
const _hoisted_53 = { id: "poor_district_count" }
const _hoisted_54 = {
  class: "bg-light",
  style: {"border-left":"1px solid #a78951"}
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("td", { style: {"border-bottom":"1px solid #9ee29e"} }, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-icon-checkmark-circle" }),
    /*#__PURE__*/_createTextVNode("Poor, "),
    /*#__PURE__*/_createElementVNode("i", { class: "fa-fa-icon-checkmark-circle" }),
    /*#__PURE__*/_createTextVNode(" Has permanent address"),
    /*#__PURE__*/_createElementVNode("i", { class: "fa-fa-con-checkmark-circle" })
  ])
], -1)
const _hoisted_56 = {
  class: "text-center",
  style: {"border-bottom":"1px solid #9ee29e"}
}
const _hoisted_57 = { id: "poor_count" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("tr", {
  class: "bg-light",
  style: {"border-bottom":"4px dotted #de243f"}
}, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("tr", {
  class: "bg-light",
  style: {"border-bottom":"4px dotted #de243f"}
}, null, -1)
const _hoisted_60 = { class: "bg-light" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("td", { style: {"border-bottom":"1px solid #9ee29e"} }, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-checkmark-circle" }),
    /*#__PURE__*/_createTextVNode("Total")
  ])
], -1)
const _hoisted_62 = {
  class: "text-center",
  style: {"border-bottom":"1px solid #9ee29e"}
}
const _hoisted_63 = { id: "total_trainee" }
const _hoisted_64 = { class: "mt-3" }
const _hoisted_65 = {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_66 = { class: "row mt-1 w-100 m-0" }
const _hoisted_67 = { class: "col-md-6" }
const _hoisted_68 = { class: "div pb-2" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-md-6 mt-1 text-end",
  "data-v-54b12dc8": ""
}, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-dark fs-7 p-2 rounded-0",
    title: "Download Xlse",
    "data-v-54b12dc8": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "fas fa-file-excel fs-5",
      "data-v-54b12dc8": ""
    }),
    /*#__PURE__*/_createTextVNode(" Excel ")
  ]),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-warning fs-7 p-2 rounded-0",
    title: "Download PDF",
    "data-v-54b12dc8": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "fas fa-file-pdf fs-5",
      "data-v-54b12dc8": ""
    }),
    /*#__PURE__*/_createTextVNode(" PDF ")
  ]),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-primary fs-7 p-2 rounded-0",
    title: "Download CSV",
    "data-v-54b12dc8": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "fas fa-file-csv fs-5",
      "data-v-54b12dc8": ""
    }),
    /*#__PURE__*/_createTextVNode(" CSV ")
  ])
], -1)
const _hoisted_70 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_71 = { class: "collapse show" }
const _hoisted_72 = { class: "card-body border-top p-6" }
const _hoisted_73 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_74 = { class: "table table-borderless gy-4" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-primary" }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"} }, " Sl "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"} }, " Name "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"} }, " Course "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"} }, " Batch "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"} }, " Bank Account & 80% Attendance "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Ethnic (A) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Challenged (B) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Female of 64 district (C) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Poor (D) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Total (A+B+C+D) "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center","color":"black !important"},
      class: "border border-grey text-center"
    }, " Actions ")
  ])
], -1)
const _hoisted_76 = { style: {} }
const _hoisted_77 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_78 = { style: {"border":"1px solid #50cd89 !important","text-align":"left"} }
const _hoisted_79 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_80 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_81 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_82 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_83 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_84 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_85 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_86 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_87 = {
  key: 0,
  style: {"border":"1px solid #50cd89 !important","text-align":"center"}
}
const _hoisted_88 = ["href"]
const _hoisted_89 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-light" }, null, -1)
const _hoisted_90 = [
  _hoisted_89
]
const _hoisted_91 = ["href"]
const _hoisted_92 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-light" }, null, -1)
const _hoisted_93 = [
  _hoisted_92
]
const _hoisted_94 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"}
}, " Total ", -1)
const _hoisted_95 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_96 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_97 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_98 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_99 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_100 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_101 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_102 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_103 = {
  key: 0,
  style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"}
}
const _hoisted_104 = ["href"]
const _hoisted_105 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-light" }, null, -1)
const _hoisted_106 = [
  _hoisted_105
]
const _hoisted_107 = ["href"]
const _hoisted_108 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-light" }, null, -1)
const _hoisted_109 = [
  _hoisted_108
]
const _hoisted_110 = ["href"]
const _hoisted_111 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-light" }, null, -1)
const _hoisted_112 = [
  _hoisted_111
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[9] || (_cache[9] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      name: "tranche_id",
                      placeholder: "Select Phase",
                      modelValue: _ctx.batch.tranche_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                      filterable: "",
                      multiple: "",
                      "collapse-tags": "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches_info, (tranche) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: tranche.id,
                            label: tranche.label,
                            value: tranche.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tranche.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _hoisted_13,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Association",
                      name: "entity_id",
                      modelValue: _ctx.batch.entity_id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                      filterable: "",
                      multiple: "",
                      "collapse-tags": "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: 
                        '[' + info.entity_short_name + '] - ' + info.entity_name
                      ,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString('[' + info.entity_short_name + '] - ' + info.entity_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createVNode(_component_el_form_item, { prop: "start_date" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.batch.start_date,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.start_date) = $event)),
                          "value-format": "YYYY-MM-DD",
                          format: "DD-MM-YYYY",
                          style: {"width":"100%"},
                          type: "date",
                          name: "start_date"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createVNode(_component_el_form_item, { prop: "end_date" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.batch.end_date,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.end_date) = $event)),
                          "value-format": "YYYY-MM-DD",
                          format: "DD-MM-YYYY",
                          style: {"width":"100%"},
                          type: "date",
                          name: "end_date"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("button", {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getStipendCourse())),
                      type: "button",
                      class: "btn btn-success mt-4",
                      style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                    }, [
                      _createTextVNode(" Search "),
                      _hoisted_19
                    ])
                  ])
                ]),
                (_ctx.showDetails == true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("h3", _hoisted_24, " Quarter " + _toDisplayString(_ctx.batch.start_date) + " to " + _toDisplayString(_ctx.batch.end_date), 1)
                          ])
                        ]),
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createElementVNode("table", _hoisted_26, [
                            _hoisted_27,
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", _hoisted_28, [
                                _createElementVNode("td", _hoisted_29, [
                                  _createElementVNode("button", {
                                    "data-kt-drawer-toggle": "true",
                                    "data-kt-drawer-target": "#kt_drawer_stipend_course",
                                    id: "kt_drawer_stipend_course_button",
                                    style: {"font-weight":"500","color":"#4987f5","background":"none","border":"0px"},
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (this.generateStipendCourse()))
                                  }, " Course must have special stipend flag enabled & duration must be 2 months or more ")
                                ]),
                                _createElementVNode("td", _hoisted_30, [
                                  _createElementVNode("span", _hoisted_31, _toDisplayString(this.Stipend_course), 1)
                                ])
                              ]),
                              _createElementVNode("tr", _hoisted_32, [
                                _hoisted_33,
                                _createElementVNode("td", _hoisted_34, [
                                  _createElementVNode("span", _hoisted_35, _toDisplayString(this.batch_completed), 1)
                                ])
                              ]),
                              _createElementVNode("tr", _hoisted_36, [
                                _hoisted_37,
                                _createElementVNode("td", _hoisted_38, [
                                  _createElementVNode("span", _hoisted_39, _toDisplayString(this.bankplusattendancesum), 1)
                                ])
                              ]),
                              _hoisted_40,
                              _hoisted_41,
                              _createElementVNode("tr", _hoisted_42, [
                                _hoisted_43,
                                _createElementVNode("td", _hoisted_44, [
                                  _createElementVNode("span", _hoisted_45, _toDisplayString(this.ethnic_trainee_number), 1)
                                ])
                              ]),
                              _createElementVNode("tr", _hoisted_46, [
                                _hoisted_47,
                                _createElementVNode("td", _hoisted_48, [
                                  _createElementVNode("span", _hoisted_49, _toDisplayString(this.physically_disabled_trainee_number), 1)
                                ])
                              ]),
                              _createElementVNode("tr", _hoisted_50, [
                                _createElementVNode("td", _hoisted_51, [
                                  _createElementVNode("button", {
                                    "data-kt-drawer-toggle": "true",
                                    "data-kt-drawer-target": "#kt_drawer_stipend_district",
                                    id: "kt_drawer_stipend_district_button",
                                    style: {"font-weight":"500","color":"#4987f5","background":"none","border":"0px"},
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => (this.generateDistrict()))
                                  }, " Female of All District ")
                                ]),
                                _createElementVNode("td", _hoisted_52, [
                                  _createElementVNode("span", _hoisted_53, _toDisplayString(this.female_trainee_number), 1)
                                ])
                              ]),
                              _createElementVNode("tr", _hoisted_54, [
                                _hoisted_55,
                                _createElementVNode("td", _hoisted_56, [
                                  _createElementVNode("span", _hoisted_57, _toDisplayString(this.poor_trainee_number), 1)
                                ])
                              ]),
                              _hoisted_58,
                              _hoisted_59
                            ]),
                            _createElementVNode("tfoot", null, [
                              _createElementVNode("tr", _hoisted_60, [
                                _hoisted_61,
                                _createElementVNode("td", _hoisted_62, [
                                  _createElementVNode("b", null, [
                                    _createElementVNode("span", _hoisted_63, _toDisplayString(this.total), 1)
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])), [
                          [_directive_loading, _ctx.load]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("h4", _hoisted_64, _toDisplayString(this.dynamicHeading), 1),
                        (_openBlock(), _createElementBlock("div", {
                          class: "card mb-5 mt-5 mb-xl-10",
                          key: _ctx.componentKey
                        }, [
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("div", _hoisted_66, [
                              _createElementVNode("div", _hoisted_67, [
                                _createElementVNode("div", _hoisted_68, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control ps-10 w-200px mt-1 form-control-sm",
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.search) = $event)),
                                    onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.searchItems())),
                                    style: {"height":"1em"},
                                    placeholder: "Search"
                                  }, null, 544), [
                                    [_vModelText, _ctx.search]
                                  ])
                                ])
                              ]),
                              _hoisted_69
                            ])
                          ]),
                          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_70, [
                            _createElementVNode("div", _hoisted_71, [
                              _createElementVNode("div", _hoisted_72, [
                                _createElementVNode("div", _hoisted_73, [
                                  _createElementVNode("table", _hoisted_74, [
                                    _hoisted_75,
                                    _createElementVNode("tbody", _hoisted_76, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.stipendList, (data, key) => {
                                        return (_openBlock(), _createElementBlock("tr", { key: key }, [
                                          _createElementVNode("td", _hoisted_77, _toDisplayString(key + 1), 1),
                                          _createElementVNode("td", _hoisted_78, _toDisplayString(data?.entity_short_name
                                          ? data?.entity_short_name
                                          : data?.institute_name), 1),
                                          _createElementVNode("td", _hoisted_79, _toDisplayString(data?.course_num), 1),
                                          _createElementVNode("td", _hoisted_80, _toDisplayString(data?.batch_num), 1),
                                          _createElementVNode("td", _hoisted_81, _toDisplayString(data?.bank_account_trainee), 1),
                                          _createElementVNode("td", _hoisted_82, _toDisplayString(data?.ethnic_trainee), 1),
                                          _createElementVNode("td", _hoisted_83, _toDisplayString(data?.disabled_trainee), 1),
                                          _createElementVNode("td", _hoisted_84, _toDisplayString(data?.female_trainee), 1),
                                          _createElementVNode("td", _hoisted_85, _toDisplayString(data?.poor_trainee), 1),
                                          _createElementVNode("td", _hoisted_86, _toDisplayString(data?.ethnic_trainee +
                                        data?.disabled_trainee +
                                        data?.female_trainee +
                                        data?.poor_trainee), 1),
                                          (
                                        data?.ethnic_trainee +
                                          data?.disabled_trainee +
                                          data?.female_trainee +
                                          data?.poor_trainee >
                                        0
                                      )
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_87, [
                                                (this.batch.entity_id.length == 1)
                                                  ? (_openBlock(), _createElementBlock("a", {
                                                      key: 0,
                                                      target: "_blank",
                                                      href: 
                                          `${this.VUE_APP_TMS}/stipend/stipend-trainee-view?entity_id=` +
                                          data?.entity_id +
                                          '&tranche_id=' +
                                          this.batch.tranche_id +
                                          '&start_date=' +
                                          this.batch.start_date +
                                          '&end_date=' +
                                          this.batch.end_date +
                                          '&institute_id=' +
                                          data?.training_institute_id
                                        ,
                                                      class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1",
                                                      "data-search-type": "course",
                                                      "data-search-key": "",
                                                      title: "Training Course"
                                                    }, _hoisted_90, 8, _hoisted_88))
                                                  : _createCommentVNode("", true),
                                                (
                                          this.batch.entity_id.length >= 2 ||
                                          this.batch.entity_id.length == 0
                                        )
                                                  ? (_openBlock(), _createElementBlock("a", {
                                                      key: 1,
                                                      target: "_blank",
                                                      href: 
                                          `${this.VUE_APP_TMS}/stipend/stipend-trainee-view?entity_id=` +
                                          data?.id +
                                          '&tranche_id=' +
                                          this.batch.tranche_id +
                                          '&start_date=' +
                                          this.batch.start_date +
                                          '&end_date=' +
                                          this.batch.end_date +
                                          '&institute_id=' +
                                          -1
                                        ,
                                                      class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1",
                                                      "data-search-type": "course",
                                                      "data-search-key": "",
                                                      title: "Training Course"
                                                    }, _hoisted_93, 8, _hoisted_91))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128)),
                                      _createElementVNode("tr", null, [
                                        _hoisted_94,
                                        _createElementVNode("td", _hoisted_95, _toDisplayString(this.total_course_num), 1),
                                        _createElementVNode("td", _hoisted_96, _toDisplayString(this.total_batch_num), 1),
                                        _createElementVNode("td", _hoisted_97, _toDisplayString(this.total_bank_account_trainee), 1),
                                        _createElementVNode("td", _hoisted_98, _toDisplayString(this.ethnic_trainee), 1),
                                        _createElementVNode("td", _hoisted_99, _toDisplayString(this.disable_trainee), 1),
                                        _createElementVNode("td", _hoisted_100, _toDisplayString(this.female_trainee), 1),
                                        _createElementVNode("td", _hoisted_101, _toDisplayString(this.poor_trainee), 1),
                                        _createElementVNode("td", _hoisted_102, _toDisplayString(this.total_sum), 1),
                                        (this.total_sum > 0)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_103, [
                                              (this.batch.entity_id.length == 1)
                                                ? (_openBlock(), _createElementBlock("a", {
                                                    key: 0,
                                                    target: "_blank",
                                                    href: 
                                        `${this.VUE_APP_TMS}/stipend/stipend-trainee-view?entity_id=` +
                                        this.batch.entity_id +
                                        '&tranche_id=' +
                                        this.batch.tranche_id +
                                        '&start_date=' +
                                        this.batch.start_date +
                                        '&end_date=' +
                                        this.batch.end_date +
                                        '&institute_id=' +
                                        -1
                                      ,
                                                    class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1",
                                                    "data-search-type": "course",
                                                    "data-search-key": "",
                                                    title: "Training Course"
                                                  }, _hoisted_106, 8, _hoisted_104))
                                                : _createCommentVNode("", true),
                                              (this.batch.entity_id.length >= 2)
                                                ? (_openBlock(), _createElementBlock("a", {
                                                    key: 1,
                                                    target: "_blank",
                                                    href: 
                                        `${this.VUE_APP_TMS}/stipend/stipend-trainee-view?entity_id=` +
                                        this.batch.entity_id +
                                        '&tranche_id=' +
                                        this.batch.tranche_id +
                                        '&start_date=' +
                                        this.batch.start_date +
                                        '&end_date=' +
                                        this.batch.end_date +
                                        '&institute_id=' +
                                        -1
                                      ,
                                                    class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1",
                                                    "data-search-type": "course",
                                                    "data-search-key": "",
                                                    title: "Training Course"
                                                  }, _hoisted_109, 8, _hoisted_107))
                                                : _createCommentVNode("", true),
                                              (this.batch.entity_id.length == 0)
                                                ? (_openBlock(), _createElementBlock("a", {
                                                    key: 2,
                                                    target: "_blank",
                                                    href: 
                                        `${this.VUE_APP_TMS}/stipend/stipend-trainee-view?entity_id=` +
                                        -1 +
                                        '&tranche_id=' +
                                        this.batch.tranche_id +
                                        '&start_date=' +
                                        this.batch.start_date +
                                        '&end_date=' +
                                        this.batch.end_date +
                                        '&institute_id=' +
                                        -1
                                      ,
                                                    class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1",
                                                    "data-search-type": "course",
                                                    "data-search-key": "",
                                                    title: "Training Course"
                                                  }, _hoisted_112, 8, _hoisted_110))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])), [
                            [_directive_loading, _ctx.selectraineeLoad]
                          ])
                        ]))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}